<template>
  <div class="home roomScreen">
    <!-- <div :class="`topHead ctgmoney91 `">
      <span class="goBack">
        <i class="material-icons">arrow_back</i>
      </span>

      <span class="catgoryIcon">
        <img :src="require(`../assets/images/Go-live_logo.png`)" />
      </span>
      <span class="catgoryTitle">
        money91
      </span>
    </div> -->
    <div class="liveContentPanel">
      <!-- <div class="circle"></div> -->

      <!-- <div class="liveUserScreen"> -->
      <!-- <div class="main-container"> -->
      <loading :active.sync="isLoading"></loading>
      <div class="videoGrid">
        <!-- <div v-if="liveUser.length == 0" class="videoGridItem noUser-grid">
          <img src="../assets/images/blankUser.png" />
          <div class="noUser-box">
            <p class="noUser">अभी कोई लाइव नहीं है।</p>
            <img src="../assets/images/noUser.png" />
          </div>
        </div> -->

        <div
          v-if="liveUser.length == 0"
          class="videoGridItem ph-item"
          v-for="user in ['1', '2', '3', '4']"
        >
          <img src="../assets/images/avatar1.jpg" />
          <div class="userdesc-box">
            <div class="userIconImage">
              <img src="../assets/images/avatar1.png" />
            </div>
          </div>
        </div>

        <div
          v-for="user in liveUser"
          :key="user.mobile_no"
          class="videoGridItem"
          @click="userVideo(user.room_id, user.content_id, user.x_auth_id)"
        >
          <i class="far fa-eye">{{ user.user_count }}</i>
          <img v-if="user.image" :src="user.image" alt="image" />
          <img v-else src="../assets/images/avatar1.jpg" />
          <div class="userdesc-box">
            <div class="userIconImage">
              <img v-if="user.image" :src="user.image" alt="image" />
              <img v-else src="../assets/images/avatar1.png" />
            </div>
            <span class="text-title">{{ user.first_name }}</span>
            <div class="user-status">
              <div class="attr-item location">
                <i class="fas fa-map-marker-alt"></i>
                {{ user.location }}
              </div>
              <div class="attr-item view">
                <span class="counter">
                  <ul class="grafica bar">
                    <li>
                      <span>&nbsp;</span>
                    </li>
                    <li>
                      <span>&nbsp;</span>
                    </li>
                    <li>
                      <span>&nbsp;</span>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- </div> -->
      <div
        id="yTVideoModal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div class="modal-dialog yTVideoModal" role="document">
          <div class="modal-content">
            <button
              type="button"
              class="close yTVideoModalCloseIcon"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/b94Hl-GywJs"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <!-- <footer>
        <div class="mainPageFooter">
          <button class="btn btn-danger" @click="handleJoin">
            <img src="../assets/images/goLive_Icon.png" />
            {{ $t('goLive') }}
          </button>
        </div>
      </footer> -->
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import Loading from 'vue-loading-overlay'
import { BASE_API_URL } from '../utils/constant'
export default {
  name: 'RoomListing',
  components: {
    Loading
  },
  props: {
    msg: String
  },

  data() {
    return {
      preloader: true,
      previousCategoryViewer: '',
      selectedCategoryViewer: this.$store.getters.selected,
      isLoading: false,
      bootOutUserData: null,
      channel: '',
      attendeeMode: 'video',
      liveUser: [],
      xAuthId: Cookies.get('X-Auth-Id') || null,
      permission: [
        'android.permission.CAMERA',
        'android.permission.RECORD_AUDIO',
        'android.permission.WRITE_EXTERNAL_STORAGE',
        'android.permission.READ_EXTERNAL_STORAGE'
      ]
    }
  },
  mounted() {
    this.zoomCategoryOption()
    this.changeLocale()
    // this.$router.push('/')
    const [extra, category] = this.$route.fullPath.split('?')
    this.selectedCategoryViewer = category
    // this.$socket.emit('categories_wise_live_user', {
    //   category: this.selectedCategoryViewer
    // })
    this.$socket.emit('all_live_user')
    const _this = this
    __native_money91.checkForPermissionResult = function(res) {
      if (res === '') {
        _this.$router.push({
          path: 'video',
          query: { u: _this.attendeeMode, c: _this.channel }
        })
      } else {
        _this.$toast.bottom(this.$t('startCamera'))
      }
    }
    console.log()
    // this.$socket.emit('categories_wise_live_user', {
    //   category: this.selectedCategoryViewer || 'money91'
    // })
    this.$store.commit('updateSelected', {
      selected: this.$store.getters.selected
    })
  },

  sockets: {
    live_user: function(data) {
      this.isLoading = false
      this.liveUser = Object.values(data.data)
      this.$store.commit('liveUserList', Object.values(data.data))
      // if (
      //   Object.values(data.data).length &&
      //   data.data.hasOwnProperty(this.selectedCategoryViewer)
      // ) {
      //   this.liveUser = Object.values(data.data[this.selectedCategoryViewer])
      // } else {
      //   this.liveUser = []
      // }
    },
    new_live_user: function(data) {
      this.isLoading = false
      this.liveUser.push(data)
      // if (this.selectedCategoryViewer === data.category) {
      //   }
      this.preloader = false
    },
    changed_category: function(data) {
      console.log('-----data---', data)
    },
    remove_user: function(data) {
      for (var i in this.liveUser) {
        if (this.liveUser[i].room_id === data.data) {
          this.liveUser.splice(i, 1)
        }
      }
    },
    blocking_user_from_watching_live_user: function(data) {
      if (data.is_kicked_out) {
        this.$toast.top(this.$t('broadcastKicked'))
      } else {
        this.enterInRoom(data.room_id)
      }
      this.isLoading = false
    }
  },

  methods: {
    zoomCategoryOption() {
      // $('.inner-category ul li').addClass('zoomCategoryOption')
      $('.inner-category ul li:nth-child(3)').addClass('zoomQuestionOption')
    },
    // goBack() {
    //   this.$router.go(-1)
    // },
    changeLocale(locale) {
      if (['bn', 'gu'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-multi')
      }
      if (['ml'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-ml')
      }
      if (['pa', 'kn'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-pa')
      }
      if (['ta'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-ta')
      }
      if (['te'].includes(this.$cookie.get('lang'))) {
        document.querySelector('body').classList.add('lang-te')
      }
      this.$i18n.locale = this.$cookie.get('lang') || 'hi'
    },
    handleCategorySelectHome(category) {
      this.previousCategoryViewer = this.selectedCategoryViewer
      // this.$socket.emit('categories_wise_live_user', { category: category })
      this.selectedCategoryViewer = category
      this.$store.commit('updateSelected', {
        selected: category
      })
      return
    },
    userVideo(channel_id, content_id, x_auth_id) {
      console.log(
        '----====----=channel_id, content_id, x_auth_id--=-',
        channel_id,
        content_id,
        Cookies.get('X-Auth-Id')
      )
      // if (this.$store.getters.selected === 'questionary') {
      //   this.$socket.emit('qna_live_user', {
      //     xAuthId: Cookies.get('X-Auth-Id'),
      //     room_id: channel_id
      //   })
      // } else {

      // }
      this.$socket.emit('watch_user_live', {
        xAuthId: Cookies.get('X-Auth-Id'),
        room_id: channel_id
      })
      this.isLoading = true
    },
    enterInRoom(channel_id) {
      clevertap.event.push('BROADCASTER_VIEWED', {
        id: this.xAuthId
      })
      this.channel = channel_id
      this.attendeeMode = 'audience'
      Cookies.set('channel', this.channel)
      Cookies.set('attendeeMode', this.attendeeMode)
      this.$router.push({
        path: 'video',
        query: { u: this.attendeeMode, c: this.channel }
      })
    },

    handleJoin() {
      clevertap.event.push('GOING_TO_BROADCAST', {
        id: this.xAuthId
      })
      this.isLoading = true
      var appVersion = Cookies.get('version-code')
      if (appVersion >= 44) {
        this.$http
          .post(BASE_API_URL + '/user_verification', { xAuthId: this.xAuthId })
          .then(result => {
            if (result.body.allowed) {
              var _ = [
                'android.permission.CAMERA',
                'android.permission.RECORD_AUDIO',
                'android.permission.WRITE_EXTERNAL_STORAGE',
                'android.permission.READ_EXTERNAL_STORAGE'
              ]
              this.$router.push({
                path: 'video',
                query: {
                  u: this.attendeeMode,
                  c: this.channel
                }
              })
              JSBridgePlugin.checkForPermission(
                _,
                true,
                '__native_money91.checkForPermissionResult'
              )
            } else {
              this.$toast.bottom(result.body.message)
            }
            this.isLoading = false
          })
      } else {
        this.$toast.bottom(this.$t('upgradeApp'))
      }
    },
    openModal() {
      $('#yTVideoModal').modal('show')
      $('#yTVideoModal').on('hide.bs.modal', function(e) {
        var $if = $(e.delegateTarget).find('iframe')
        var src = $if.attr('src')
        $if.attr('src', '/empty.html')
        $if.attr('src', src)
      })
    },

    closeOrOpenwhatsNewModel(toggleModal) {
      $('.whatconttentbox').modal(toggleModal)
    },

    openTv91() {
      window.location.href =
        'http://tv.money91.com/#/login-via-url/' +
        this.xAuthId +
        '?lng=' +
        this.$cookie.get('lang')
    }
  }
}
</script>
<style scoped>
.noLiveUserScreen {
  left: 50%;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}
.noLiveUserScreen .main-container {
  height: 250px;
}
.noLiveUserScreen .main-container .btn {
  float: right;
  margin: 10px;
  font-size: 16px;
}
.liveUserScreen .main-container {
  height: auto;
}
</style>
